import notificationActions
// @ts-ignore
  from "@cirrus/legacy/app-author/alt/application/application/children/notification/actions/actions.es6"
import {
  notificationType
// @ts-ignore
} from "@cirrus/legacy/app-author/alt/application/application/children/notification/constants/constants.es6"

/**
 * @deprecated The method should not be used
 * useNotifications() hook should be used instead
 */
export const showNotificationMessage = (type: notificationType, text: string) =>
  notificationActions.show(type, text)

/**
 * @deprecated This should not be used
 */
export const NotificationType = notificationType
